export const defaultConfigState = {
  /**
   * Cờ đang xử lý
   */
  Loading: false,
  /**
   * Token đăng nhập
   */
  Token: null,
  /**
   * Đã getting chưa
   * Nếu chưa thì sẽ điều hướng về màn hình getting
   */
  GettingStarted: false,
  /*
   * Trạng thái Collapse của left menu
   */
  LeftMenuCollapse: false,
  /**
   * Phiên làm việc
   */
  Context: {
    /**
     * Chi nhánh hiện tại
     */
    OrganizationUnitID: 1,
    /**
     * Ngôn ngữ hiện tại
     */
    Culture: "vi",

    /**
     * MisaCodeID mặc định
     */
    MISACodeID: "/000/"
  },
  /**
   * Thông tin org trả về cùng context
   */
  OrganizationUnit: null,
  /**
   * Thông tin phân quyền
   * Key là subsystemCode, value sẽ là mảng string danh sách perrmission
   */
  Permission: {},

  /**
   * Thông tin thuê bao
   */
  License: {},

  /**
   * Thông tin tài khoản
   */
  User: {
    UserID: null,
    Email: null,
    FullName: null,
    Mobile: null,
    UserName: null
  },

  /**
   * Thông tin config
   */
  ConfigInfo: {
    CurrentDate: new Date(),
    CurrentDateText: ""
  },
  /**
   * Định dạng số
   */
  NumberFormat: {
    GeneralDecimalSeparator: ",",
    GeneralGroupSeparator: ".",

    QuantityDecimalDigits: 1,
    AmountDecimalDigits: 2,
    AmountOCDecimalDigits: 2,
    UnitPriceDecimalDigits: 1,
    UnitPriceOCDecimalDigits: 1,
    ExchangRateDecimalDigits: 2,
    CoefficientDecimalDigits: 2,
    AllocationDecimalDigits: 2
  },
  OptionsData: {},
  /**
   * Cờ đánh dấu là mới đăng nhập xong, dùng để phân biệt vs f5
   */
  FirstLogin: false,
};

export default {
  ...defaultConfigState
};
